export default "__VITE_ASSET__DOY5DqNf__"